export default __webpack_public_path__ + "static/39-9f02a2015c1e76f926ac07c42e55a7e5.png";